import React from 'react';
import { View, StyleSheet } from 'react-native';
import { rem, Spacer, SuperSquircle } from 'design-system';
import Text from 'design-system/Text';
const Row = ({ Icon, title, value, ...props }) => (<View style={styles.container}>
    {Icon ? (<>
        <SuperSquircle>
          <Icon {...props}/>
        </SuperSquircle>
        <Spacer.W16 />
      </>) : null}
    <Text Text-16 flex style={styles.text}>
      {title}
    </Text>
    {Boolean(value) && <Text Numbers-16>{value}</Text>}
  </View>);
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: rem(16),
    },
    text: {
        flexShrink: 1,
    },
});
export default Row;
